function ConnectionReason(aAssociation, aDescription) {
    this.Description = aDescription;
    this.Id = aAssociation.PointGroupingId;
}
if (typeof exports !== 'undefined') {
    module.exports = ConnectionReason;
}